import {CornerDownIcon, Grid} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import {useCallback} from 'react'

import {TitleSlot} from 'src/shared/components/desktop'

import {usePointTitle} from '../../hooks/use-point-title'
import {PointDetails} from '../../point-details/PointDetails'
import {PointIcon} from '../../point-icon/PointIcon'
import {removeLeadingPostalCode} from '../../utils/remove-leading-postal-code'
import {classes} from './PointItem.classes'
import type {Props} from './types'

export function PointItem(props: Props) {
  const {point, pointType, selectedPointId, onSelect, onPointChoose} = props
  const title = usePointTitle(point, pointType)
  const isPointDetailsVisible = selectedPointId === point?.id

  const clickHandler = useCallback(() => {
    onSelect(point)
  }, [onSelect, point])

  return (
    <Grid direction="column" container>
      <Grid item xs>
        <TitleSlot
          className={classes.clickable}
          endIcon={
            <CornerDownIcon className={clsx(classes.iconClosed, {[classes.iconOpened]: isPointDetailsVisible})} />
          }
          onClick={clickHandler}
          size="s"
          startIcon={<PointIcon point={point} />}
          subtitle={removeLeadingPostalCode(point?.address?.full_address)}
          subtitleTypography={{group: 'normal', variant: 'caption1', color: 'minor'}}
          title={title}
          titleTypography={{variant: 'body2', thickness: 'medium', group: 'tight'}}
        />
      </Grid>

      {isPointDetailsVisible && (
        <Grid item xs>
          <PointDetails onChoose={onPointChoose} point={point} pointType={pointType} />
        </Grid>
      )}
    </Grid>
  )
}
